<template>
  <div
    v-if="!navigating"
    class="bg-[#F6F4F0] fixed inset-0 z-[9999] min-h-screen flex flex-col px-[24px]"
  >
    <div class="mt-[16px] mb-[32px]">
      <button
        @click="goBack"
        class="flex pt-[8px] pb-[8px] items-center text-[#2B2926]"
        :class="{ '!pt-[92px]': isIos() }"
      >
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="32" height="32" rx="16" fill="#F2EFED" />
          <path
            d="M20.6667 16.0007H11.3333M11.3333 16.0007L16 20.6673M11.3333 16.0007L16 11.334"
            stroke="#191817"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <div class="mb-[40px]">
      <h1 class="text-[2rem] font-[900] text-[#433D31] mb-[8px]">Forgot PIN</h1>
      <p class="text-[1rem] font-semibold text-[#433D31] leading-[1.5rem]">
        Your PIN has been reset 😇<br /><br />
        Now, create a new PIN to keep your giving records secure.
      </p>
    </div>

    <div class="flex-1"></div>

    <div class="mb-[32px]">
      <button
        @click="goToCreatePin"
        class="w-full py-[16px] rounded-full font-bold text-[1rem] bg-[#322A21] text-white active:scale-[0.98] transition"
      >
        Create PIN
      </button>
    </div>
  </div>
</template>

<script>
import { isIosNativeOnly } from '@/utils/platform-check';

export default {
  name: 'ForgotPinSuccessPage',

  data() {
    return {
      navigating: false,
    };
  },

  mounted() {
    console.log('ForgotPinSuccessPage: Mounted');
  },

  methods: {
    goBack() {
      console.log('Success: Going back');
      this.$router.go(-1);
    },

    async goToCreatePin() {
      console.log('Success: Navigating to Create PIN');
      this.navigating = true;

      await this.$nextTick();

      this.$router.replace('/my-giving/pin/create-pin');
    },

    isIos() {
      return isIosNativeOnly();
    },
  },
};
</script>
